/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react';
import 'moment/locale/pt';

import moment from 'moment'
import { Box, Button, FormControl, Tab, Tabs, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import InputMask from "react-input-mask";
import { removeCpfMask } from '../../../../../utils/functions';
import { enqueueSnackbar } from 'notistack';

export default function filterModal({ open, onClose, setProps, setFilter }) {
  const [cpf, setCpf] = useState('');
  const [value, setValue] = useState(0);

  const handleReturnInfos = () => {
    if (cpf.length < 14) {
      enqueueSnackbar('Digite o CPF completo!', { variant: 'info' });
      
      return
    }
    moment.locale('en')

    setProps(removeCpfMask(cpf))
    setFilter(true)
    onClose()
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Filtros
        </Typography>
      </Box>

      <Box sx={{
        margin: '16px',
        width: 400,
        height: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
      }}>
        <Box sx={{
          width: '100%'
        }}>
          <Box sx={{
            borderBottom: 1,
            borderColor: 'divider'
          }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Por CPF" {...a11yProps(0)} />
            </Tabs>
          </Box>
          <Box sx={{
            padding: 1,
            paddingBottom: '20px',
            paddingTop: '20px',
          }}>
            <FormControl fullWidth>
              <InputMask
                mask="999.999.999-99"
                maskChar=" "
                value={cpf}
                onChange={(event) => setCpf(event.target.value)}
                >
                {() =>
                  <TextField
                    label="CPF"
                  />}
              </InputMask>
            </FormControl>
          </Box>
        </Box>
      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button variant="contained" color={'success'} onClick={() => handleReturnInfos()}>
          <Typography color={'#fff'}>
            Filtrar
          </Typography>
        </Button>
        <Button variant="contained" color='error' onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
